import React, { useState } from 'react'
import PerksCard from './PerksCard'
import { ShoppingBag, Heart, SlidersHorizontal, CreditCard, Receipt } from 'lucide-react'
import PerkDetail from './PerkDetail'

// SAMPLE DATA
export const perksData: Perk[] = [
    {
        imageUrl: '/images/perks_images/google.png',
        // 'https://images.unsplash.com/photo-1556745757-8d76bdb6984b?q=80&w=1073&auto=format&fit=crop',
        logoUrl: '/images/perks_logos/google.png',
        title: 'Google for Small Business',
        description: 'Promote your business locally and drive foot traffic with digital ads.',
        reward: '$1,500 in Google Ads Credit',
        status: 'Redeem',
        label: 'Discount'
    },
    {
        imageUrl: '/images/perks_images/spectrum.jpg',
        // 'https://images.unsplash.com/photo-1605379399642-870262d3d051?q=80&w=1073&auto=format&fit=crop',
        logoUrl: '/images/perks_logos/spectrum.png',
        title: 'Spectrum Business',
        description: 'Reliable broadband for your store, free for the first 90 days.',
        reward: '3 Months Free Business Internet',
        label: 'Quick Buy',
        status: 'Activated'
    },
    {
        imageUrl: '/images/perks_images/springbank.png',
        // 'https://plus.unsplash.com/premium_photo-1661319063327-ccb1da3003a4?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        logoUrl: '/images/perks_logos/springbank.png',
        title: 'Spring Bank (Bronx, NY)',
        description: 'Short-term capital with no interest if repaid within 60 days.',
        reward: '0% Interest Line of Credit',
        status: 'Redeem',
        label: 'Quick Buy'
    },
    {
        imageUrl: '/images/perks_images/nav.png',
        // 'https://images.unsplash.com/photo-1607706189992-eae578626c86?q=80&w=1073&auto=format&fit=crop',
        logoUrl: '/images/perks_logos/nav.png',
        title: 'Nav',
        description: 'Track your credit score, receive alerts, and build financing readiness.',
        reward: 'Free Business Credit Monitoring',
        status: 'Redeem',
        label: 'Discount'
    },
    {
        imageUrl: '/images/perks_images/next.png',
        // 'https://images.unsplash.com/photo-1523961131990-5ea7c61b2107?q=80&w=1073&auto=format&fit=crop',
        logoUrl: '/images/perks_logos/next.png',
        title: 'NEXT Insurance',
        description:
            'Affordable protection for your storefront, staff, and operations.',
        reward: '25% off Business Insurance',
        status: 'Redeem',
        label: 'Discount'
    },
    {
        imageUrl: '/images/perks_images/clover.png',
        // 'https://images.unsplash.com/photo-1542744173-05336fcc7ad4?q=80&w=1073&auto=format&fit=crop',
        logoUrl: '/images/perks_logos/clover.png',
        title: 'Clover',
        description:
            'In-store payments made easy. No hardware or activation costs.',
        reward: 'Free POS System',
        status: 'Redeem',
        label: 'Quick Buy'
    },
    {
        imageUrl: '/images/perks_images/springbank.png',
        // 'https://plus.unsplash.com/premium_photo-1661319063327-ccb1da3003a4?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        logoUrl: '/images/perks_logos/springbank.png',
        title: 'Spring Bank (Bronx, NY)',
        description: 'Short-term capital with no interest if repaid within 60 days.',
        reward: '0% Interest Line of Credit',
        status: 'Redeem',
        label: 'Quick Buy'
    },
    {
        imageUrl: '/images/perks_images/nav.png',
        // 'https://images.unsplash.com/photo-1607706189992-eae578626c86?q=80&w=1073&auto=format&fit=crop',
        logoUrl: '/images/perks_logos/nav.png',
        title: 'Nav',
        description: 'Track your credit score, receive alerts, and build financing readiness.',
        reward: 'Free Business Credit Monitoring',
        label: 'Discount',
        status: 'Redeem',
    },
];

// at the top
interface Perk {
    imageUrl: string;
    logoUrl: string;
    title: string;
    label: string;
    reward: string;
    description: string;
    status: 'Activated' | 'Redeem';
}


export default function Perks() {
    const [showDetail, setShowDetail] = useState(false)
    const [selectedPerk, setSelectedPerk] = useState<Perk | null>(null);

    const handleSelect = (perk: Perk) => {
        setShowDetail(true)
        setSelectedPerk(perk)
    }

    const handleBack = () => {
        setShowDetail(false)
        setSelectedPerk(null)
    }

    return (
        !showDetail ? (
            <div className="m-5 md:min-w-[800px]">

                <div className="flex grid md:grid-cols-3 grid-cols-2 gap-4">
                    {perksData.map((perk, idx) => (
                        <PerksCard handleSelect={() => handleSelect(perk)} key={idx} {...perk} />
                    ))}
                </div>

            </div>) :

            selectedPerk && (
                <PerkDetail
                    handleBack={handleBack}

                    imageUrl={selectedPerk.imageUrl}
                    logoUrl={selectedPerk.logoUrl}
                    title={selectedPerk.title}
                    label={selectedPerk.label}
                    status={selectedPerk.status}
                    description={selectedPerk.description}
                    dateRange="01 Feb 2025 - 30 Apr 2025"
                    termsUrl="#"
                    howTo={[
                        {
                            icon: <ShoppingBag className="w-4 h-4 text-gray-700" />,
                            text: 'Purchase the plan online from the website.'
                        },
                        {
                            icon: <CreditCard className="w-4 h-4 text-gray-700" />,
                            text: 'Pay by any card linked to your Finz account.'
                        },
                        {
                            icon: <Receipt className="w-4 h-4 text-gray-700" />,
                            text: 'Offer will be credited to the card right after purchase.'
                        }
                    ]}
                />
            )
    )
}
